import _get from "lodash/get";
import styled, { css } from 'styled-components';
import CheckboxIndicator from '../checkbox/CheckboxIndicator';
import formTheme from '../../styles/formTheme';
var RadioIndicator = styled(CheckboxIndicator).withConfig({
  displayName: "RadioIndicator",
  componentId: "sc-1vjz750-0"
})(["border-radius:50%;border-width:4px;", ""], function (_ref) {
  var checked = _ref.checked,
      skin = _ref.skin,
      theme = _ref.theme;
  return checked && css(["background-image:", ";"], "url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%22-4%20-4%208%208%22%3E%3Ccircle%20r=%223%22%20fill=%22" + _get(theme, "theme.form.checkbox." + skin + ".indicatorColor", formTheme.form.checkbox[skin].indicatorColor).replace('#', '%23') + "%22/%3E%3C/svg%3E')");
});
export default RadioIndicator;